async function clearCacheStorage(): Promise<void> {
  if (!('caches' in window)) {
    return;
  }

  const cacheNames = await window.caches.keys();
  await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
}

async function updateServiceWorkers(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.update()));
}

async function revalidateDocument(): Promise<void> {
  await fetch(window.location.href, { cache: 'reload', credentials: 'same-origin' });
}

async function runIgnoringFailures(step: () => Promise<void>): Promise<void> {
  try {
    await step();
  } catch (error) {
    console.warn('A force refresh step failed and was skipped.', error);
  }
}

export async function forceApplicationRefresh(): Promise<void> {
  await runIgnoringFailures(clearCacheStorage);
  await runIgnoringFailures(updateServiceWorkers);
  await runIgnoringFailures(revalidateDocument);

  window.location.reload();
}
